import { Flex, Text } from '@radix-ui/themes'
import { useEffect, useState } from 'react'
import { NEUTRAL_INK, NEUTRAL_SURFACE } from '../constants'
import { GameBrandingFormData } from '../types'
import { colorOrFallback } from '../utils'
import '../styles.scss'

type BrandingPreviewProps = {
  gameName: string
  form: GameBrandingFormData
}

/**
 * A miniature of the game card the clients draw, fed by the form rather than the saved game so it
 * moves with every keystroke.
 */
export const BrandingPreview = ({ gameName, form }: BrandingPreviewProps) => {
  const logoUrl = form.logoUrl.trim()
  const [isLogoBroken, setIsLogoBroken] = useState(false)

  // A URL that failed is only broken until it is edited, so each new one gets a fresh attempt.
  useEffect(() => setIsLogoBroken(false), [logoUrl])

  return (
    <Flex direction="column" gap="2">
      <Text size="2" weight="medium">
        Preview
      </Text>
      <Flex
        data-testid="branding-preview"
        className="branding-preview"
        align="center"
        gap="3"
        style={{ backgroundColor: colorOrFallback(form.brandColorPrimary, NEUTRAL_SURFACE) }}>
        {logoUrl && !isLogoBroken && (
          <img
            data-testid="branding-preview-logo"
            className="branding-preview-logo"
            src={logoUrl}
            alt=""
            onError={() => setIsLogoBroken(true)}
          />
        )}
        <Text
          data-testid="branding-preview-name"
          className="flex-1"
          size="3"
          weight="bold"
          style={{ color: colorOrFallback(form.fontColorPrimary, NEUTRAL_INK) }}>
          {gameName}
        </Text>
        <span
          data-testid="branding-preview-ball"
          className="branding-preview-ball"
          aria-label="Special ball"
          role="img"
          style={{ backgroundColor: colorOrFallback(form.specialBallColor, NEUTRAL_SURFACE) }}
        />
      </Flex>
    </Flex>
  )
}
